import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ConfigurationService } from '../../configuration.service';
import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';
import { ProjectLanguage } from '../../firestore-models/project-language';
import { Facility } from '../../firestore-models/facility';

import { SpinnerService } from '../../services/spinner.service';
import { ApiEntranceExitUser, ApiSetEntranceExitUsersRequest } from '../../api-client-module';
import { TranslateService } from '@ngx-translate/core';

export interface UserDialogData {
  change_type: number;
  user?: ApiEntranceExitUser;
}

@Component({
  selector: 'app-entrance-exit-user-dialog',
  templateUrl: './entrance-exit-user-dialog.component.html',
  styleUrls: ['./entrance-exit-user-dialog.component.css'],
  standalone: false,
})
export class EntranceExitUserDialogComponent implements OnInit {

  projectId: string;
  user?: ApiEntranceExitUser;
  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;
  facilities: Facility[] = [];

  userFormGroup!: FormGroup;
  uidControl!: FormControl;
  nameControl!: FormControl;
  descriptionControl!: FormControl;
  emailControl!: FormControl;

  constructor(
    public dialogRef: MatDialogRef<EntranceExitUserDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: UserDialogData,
    private formBuilder: FormBuilder,
    private configurationService: ConfigurationService,
    private angularFirestore: AngularFirestore,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.projectId = this.configurationService.getProjectId();
  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.user = this.data.user;
    if (!this.user) {
      this.user = {
        project_id: this.projectId,
        uid: '',
        name: '',
        description: '',
        email: '',
        enabled: true
      };
      this.isAdded = true;
    }
    this.createForm();
    this.uidControl = this.userFormGroup.get('uid') as FormControl;
    this.nameControl = this.userFormGroup.get('name') as FormControl;
    this.descriptionControl = this.userFormGroup.get('description') as FormControl;
    this.emailControl = this.userFormGroup.get('email') as FormControl;
  }

  public getErrorMessageToName() {
    return this.nameControl.hasError('required')
      ? this.translate.instant('必須項目')
    : '';
  }

  public getErrorMessageToDescription() {
    return this.descriptionControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToEmail() {
    return this.emailControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.emailControl.hasError('email')
        ? this.translate.instant('メールアドレス')
        : '';
  }

  private createForm() {
    this.userFormGroup = this.formBuilder.group(
      {
        uid: [this.user!.uid, []],
        name: [this.user!.name, [Validators.required]],
        description: [this.user!.description, [Validators.required]],
        email: [this.user!.email, [Validators.required, Validators.email]],
      }
    );
  }

  addUser(): void {
    if (this.userFormGroup.valid) {
      this.user!.uid = this.uidControl.value;
      this.user!.name = this.nameControl.value;
      this.user!.description = this.descriptionControl.value;
      this.user!.email = this.emailControl.value;
      if (this.user) {
        let request: ApiSetEntranceExitUsersRequest = {
          access_token: '',
          change_type: this.data.change_type,
          users: [this.user]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setEntranceExitUsers(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じメールアドレスが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
